import {makeStyles} from '@material-ui/core';

export const useStyles=makeStyles({
    root:{
        minHeight:'100vh',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        position: 'relative'
    },
    paper:{
        padding: '20px',
        width: '400px',
    },
    form:{
        width:'100%'
    },
    input:{
        width: '95%',
        marginBottom:'20px',
        '& label.Mui-focused': {
            color: '#4CA1A3',
             },
            '& .MuiInput-underline:after': {
             borderBottomColor: '#511281',
            },
           '& .MuiOutlinedInput-root': {
            '& fieldset': {
            borderColor: '#4CA1A3',
            },
            '&:hover fieldset': {
             borderColor: '#4CA1A3',
              },
            '&.Mui-focused fieldset': {
              borderColor: '#511281',
            },
            },
    },
    button:{
        width:'95%',
        padding: '10px 0',
        color:'#fff',
        background:'linear-gradient(to right,#511281,#4CA1A3)'
    },
    authOptions:{
        display:'flex',
        alignItems:'center',
        width:'95%',
        margin:'10px auto',
        border:'1px solid #4CA1A3',
        borderRadius:'4px',
        padding:'10px',
        paddingLeft:'30px',
       "& span":{
            marginLeft:'30px'
        }
    },
    title:{
        backgroundImage: 'linear-gradient(to right bottom,#511281,#4CA1A3)',
        WebkitBackgroundClip: 'text',
        color: 'transparent'
    },
    fbLogin:{
        width:'95%',
        margin:'10px auto',
        borderRadius:'4px',
        height:'45px!important',
        background: '#fff',
        display:'flex',
        alignItems:'center',
        //justifyContent:'center',
        outline:'none',
        border:'1px solid #4CA1A3',
        fontSize:'15px',
        textAlign:'center',
        paddingLeft:'30px'
    },
    or:{
        display:'grid',
        width:'95%',
        margin:'15px auto',
        color:'#4CA1A3',
        gridTemplateColumns:'1fr max-content 1fr',
        gridColumnGap:'1.5rem',
        alignItems: 'center',
       "&::before,&::after":{
        content: '""',
        height: "1px",
        display:"block",
        backgroundColor:"black"
       }
    },
    bgVideoCont:{
        position: 'absolute',
        top:0,
        left:0,
        height:'100%',
        width:'100%',
        zIndex:'-1',
        opacity: '0.4',
        overflow: 'hidden',
    },
    bgVideo:{
        height:'100%',
        width:'100%',
        objectFit:'cover'
    }

})
